import React, { useEffect, useState } from 'react';
import "./priceList.css";
import api from '../../axiosInstance';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Select, MenuItem, Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Box, Gridv2, Typography, Modal } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
// import { Button, TextField,  } from "@mui/material";
// import {  Box } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import IconButton from "@mui/material/IconButton";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid2';
import TableHead from '@mui/material/TableHead';
import Swal from "sweetalert2";
import modalbg from "../../Assets/bg.jpg"
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import priceListdata from './priceListdata.json'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import CreateProductPriceList from './CreateProductPriceList';
import DeleteIcon from '@mui/icons-material/Delete';
const theme = createTheme({
    typography: {
        fontFamily: "Calibri, sans-serif",
    },
});


function DistributerProduct() {
    const { did, cid } = useParams();
    const navigate = useNavigate();


    const [distributerProducts, setDistributerProducts] = useState([])

      const [createProductDetails, setcreateProductDetails] = useState([])
    //   const [getPriceListResponseData, setgetPriceListResponseData] = useState([])
    
      const [DeleteData, setDeleteData] = useState([])

    const fetchDistributerProduct = async () => {
        try {
            const response = await api.get(`/userproduct?DISID=${did}`);
            console.log("Response", response);
    
            if (response.status === 200) {
                const data = response?.data?.data; // Ensure data exists
                if (!data) return;
    
                // Convert into an array and merge product_name into latestpricelist
                const latestPriceListWithProductName = data.map(item => ({
                    ...item.latestpricelist, // Spread latestpricelist object
                    product_name: item.product_name // Add product_name
                }));
    
                setDistributerProducts(latestPriceListWithProductName);
                console.log("Distributer Product", latestPriceListWithProductName);
            }
        } catch (error) {
            console.error('Error fetching Distributer Product:', error);
        }
    };
    


    
  const deleteProductPriceList = async (id) => {
    if (!id) {
      console.error("Error: ID is required for deletion.");
      return;
    }

    const apiUrl = `userproduct/${id}`;

    // Show confirmation dialog before deleting
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await api.delete(apiUrl);

        Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: response.data?.message || "Product price list deleted successfully.",
        });

        setDeleteData(response.data);
      } catch (error) {
        console.error("Delete Error:", error.response ? error.response.data : error.message);

        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error?.response?.data?.message || "Something went wrong.",
        });
      }
    }
  };

    useEffect(() => {
        fetchDistributerProduct();
    }, [DeleteData,createProductDetails]);
    
    

    const columns = [
        { field: "id", headerName: "ID", width: 100 },
        { field: "product_name", headerName: "Name", width: 200 },
        { field: "price", headerName: "Price", width: 150 },
        { field: "effected_from", headerName: "Date", flex: 1 },
        // {
        //     field: 'actions',
        //     headerName: 'Actions',
        //     width: 250,
        //     renderCell: (params) => (
        //       <>
        //         <div className='d-flex  align-items-center h-100 gap-4'>
        //           <IconButton >
        //             <CreateProductPriceList dpid={0} setcreateProductDetails={setcreateProductDetails} editData={params?.row}/>
        //           </IconButton>
        //           <IconButton onClick={() => deleteProductPriceList(params?.row?.up_id)}>
        //             <DeleteIcon />
        //           </IconButton>
      
        //         </div>
        //       </>
        //     ),
        //   },
        // {
        //     field: 'actions',
        //     headerName: 'Actions',
        //     width: 250,
        //     renderCell: (params) => (
        //         <>
        //             <div className='d-flex  align-items-center h-100 gap-4'>
        //                 <IconButton onClick={() => navigate(`/viewpricelist/${params.row.id}`)}>
        //                     <RemoveRedEyeIcon />
        //                 </IconButton>
        //             </div>
        //         </>
        //     ),
        // },
        // {
        //   field: "selling_price",
        //   headerName: "Selling Price",
        //   width: 180,
        //   renderCell: (params) => (
        //     <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>

        //       <TextField
        //         value={params.row.selling_price}
        //         // onChange={(e) =>
        //         //   handleChange(params.row.id, "selling_price", e.target.value)
        //         // }
        //         type="number"
        //         variant="outlined"
        //         size="small"
        //         sx={{
        //           // "& .MuiInputBase-input": {
        //           //   fontSize: "12px", // Smaller font
        //           //   height: "55px", // Reduce height
        //           // },
        //           "& .MuiOutlinedInput-root": {
        //             height: "30px", // Overall height of TextField
        //             marginTop: "10px",
        //             width: "90%",
        //           },
        //           "@media (max-width: 600px)": {
        //             "& .MuiOutlinedInput-root": {
        //               height: "30px", // Smaller height on small screens
        //               width: "80%",
        //             },
        //           },
        //         }}
        //       />
        //     </Box>
        //   ),

        // },

    ];



    console.log("did", priceListdata)

    return (
        <div className='row' style={{ height: "100%" }}>
            <div className='col-sm-12 col-md-12'>
                <div style={{ height: "100%" }}>
                    <div className=" d-flex flex-warp justify-content-between align-items-center p-2">
                        <h3 className='distributerfont'>Assign Product List</h3>
                        <div>

                            <div className='d-flex align-items-center' >
                                <TextField
                                    id="standard-basic"
                                    placeholder="Search"
                                    variant="standard"
                                    className='me-2'
                                    sx={{
                                        width: "8rem", // Set width
                                        // "& input": {
                                        //   fontSize: "14px", // Text inside the input field
                                        // },
                                        "& .MuiInputBase-input::placeholder": {
                                            fontSize: "12px", // Reduce placeholder size

                                        },
                                    }}

                                />
                                <div className='search_icon'>
                                    <SearchIcon fontSize='7px' />

                                </div>
                                <PersonIcon className='ms-2' />
                                <div>

                                </div>
                            </div>
                        </div>


                    </div>
                    <div className='d-flex justify-content-end'>
                        {/* <button
              type="button"
              className="rounded submitbutton m-1"
              onClick={handleInvestmentOpen}
            >
              Add Investment
            </button> */}
                        {/* <button
              type="button"
              className="rounded submitbutton m-1 "
              onClick={() => {
                setShowForm(!showForm); // Toggle form visibility
              }}

            >
              {showForm ? "Price List" : "Create Price List"}
            </button> */}
                        {/* Investment Modal */}
                        {/* <Dialog open={investmentModal} onClose={handleInvestmentClose} fullWidth maxWidth="sm">
              <DialogTitle>Enter Investment Amount</DialogTitle>
              <DialogContent>
                <TextField
                  label="Investment Amount"
                  type="number"
                  fullWidth
                  variant="outlined"
                  value={investmentAmount}
                  onChange={(e) => setInvestmentAmount(e.target.value)}
                  margin="normal"
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={handleInvestmentClose} color="secondary">
                  Cancel
                </Button>
                <Button onClick={handleInvestmentSubmit} color="primary" variant="contained">
                  Submit
                </Button>
              </DialogActions>
            </Dialog> */}
                    </div>

                    <div className='d-flex justify-content-end align-items-center'>
                        <Button
                            onClick={() => navigate(`/createpricelist/${did}`)}
                            variant="contained"
                            color="primary"
                            startIcon={<ReceiptLongIcon />}
                        >
                            Add Product
                        </Button>
                    </div>
                    <div>
                        <ThemeProvider theme={theme}>
                            <div style={{ height: 400, width: "100%" }}>

                                <DataGrid
                                    rowSpacingType='border'

                                    rows={distributerProducts}
                                    columns={columns}
                                    // rowsPerPageOptions={[5]}
                                    checkboxSelection  // Enable checkbox selection
                                    disableRowSelectionOnClick
                                    // onRowSelectionModelChange={(newRowSelectionModel) => {
                                    //   setRowSelectionModel(newRowSelectionModel);
                                    // }}
                                    // rowSelectionModel={rowSelectionModel}
                                    pagination={false}
                                    hideFooter
                                    sx={{
                                        border: 'none', // Change outer border color
                                        fontFamily: "Calibri, sans-serif",
                                        "& .MuiCheckbox-root": {
                                            padding: "4px",  // Reduce padding
                                            transform: "scale(0.7)",  // Scale down checkbox size
                                        },
                                        "& .MuiDataGrid-row": {
                                            border: "1px solid #dee2e6 !important",  // Remove row border
                                            marginTop: "0.2rem",

                                        },
                                        "& .MuiDataGrid-cell": {
                                            border: "none !important",  // Remove cell borders
                                        },
                                        "& .MuiDataGrid-columnHeaders": {
                                            border: "none !important", // Remove header row bottom border

                                        },
                                        "& .MuiDataGrid-filler": {
                                            rowBorderColor: "none"
                                        },
                                        "& .MuiDataGrid-root": {
                                            border: "none !important", // Removes outer border
                                        },

                                    }}

                                />
                            </div>
                            {/* <div className='d-flex justify-content-end'>
                    <button className='submitbutton mt-2' onClick={handleSubmit}>
                      Submit
                    </button>
                  </div> */}
                        </ThemeProvider>
                    </div>

                </div>
            </div>
            {/* <div className='col-sm-12 col-md-3 distributerSideimage rounded-5 mt-md-0 mt-2 distributerfont'>
                <div className="bg-white my-4 mx-2 p-3 rounded-5">
                    <h5>Details</h5>
                    <p>
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam praesentium vel harum tempore eaque asperiores? Delectus voluptatum eligendi tempore fugit labore, officiis reiciendis, deserunt sunt cupiditate, minus sed omnis eveniet.
                    </p>
                </div>

            </div> */}


        </div>
    )
}

export default DistributerProduct